// Block colouring for the vehicle availability week view, shared between the
// on-screen timeline and the printed PDF so the legends always match.
export const BLOCK_COLORS = {
  ptsDuty: '#0F766E', // teal — PTS duty
  event: '#1D4ED8', // blue — event deployment
  unavailable: '#B91C1C', // red — marked unavailable
}

export const BLOCK_LABELS = {
  ptsDuty: 'PTS duty',
  event: 'Event deployment',
  unavailable: 'Unavailable',
}
